import * as types from "./mutation-types";

export default {
  [types.SET_TIPOS_CONCEDENTES](state, payload) {
    state.tipos_concedentes = payload;
  },
  [types.SET_TIPO_CONCEDENTE](state, payload) {
    state.tipo_concedente = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  }
};
